import React from "react";
import { Skeleton } from "antd";

import { ServiceListItem } from "./BusinessServicesListItem.styles";

const BusinessServicesListItemSkeleton: React.FC = () => {
  return (
    <ServiceListItem actions={[<Skeleton.Button active />]}>
      <Skeleton
        active
        paragraph={{
          rows: 1,
        }}
      />
    </ServiceListItem>
  );
};

export default BusinessServicesListItemSkeleton;
